/* VZ · Join the Astute Society panel — UX Boost preview 193684111652 */
(function(){
  var d=document,w=window,SS,LS;try{SS=w.sessionStorage;LS=w.localStorage}catch(e){return}
  var box=d.querySelector('[data-vzaj]');if(!box||box.__vzaj)return;box.__vzaj=1;
  var f=box.querySelector('[data-vzaj-step=form]'),ok=box.querySelector('[data-vzaj-step=ok]'),form=box.querySelector('form');
  function showOk(){f.hidden=true;ok.hidden=false;}
  if(form)form.addEventListener('submit',function(){SS.setItem('vzaj-sent','1');SS.setItem('vzx-pop-seen','1');});
  var posted=/[?&]customer_posted=true/.test(location.search);
  if(SS.getItem('vzaj-sent')){
    SS.removeItem('vzaj-sent');
    var err=box.querySelector('[data-vzaj-err]');
    if(posted&&!err){LS.setItem('vzx-subscribed','1');showOk();}
    else if(err){err.hidden=false;}
    setTimeout(function(){box.scrollIntoView({block:'center'});},300);
  } else if(/[?&]vzaj_ok=1/.test(location.search)){showOk();} /* preview helper: shows the success state without subscribing */
  box.addEventListener('click',function(e){var c=e.target.closest('[data-vzaj-copy]');if(!c)return;var code=c.getAttribute('data-vzaj-copy'),s=c.querySelector('span');
    (navigator.clipboard?navigator.clipboard.writeText(code):Promise.reject()).catch(function(){}).then(function(){if(s)s.textContent='COPIED';});});
})();
